export default __webpack_public_path__ + "static/media/sa-img.bdee4307.webp";